import React from 'react';
import { Helmet } from 'react-helmet-async';
import './LegalPages.css';

const TermsOfService = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Service - One Piece Trivia</title>
        <meta name="description" content="Terms of Service for One Piece Trivia. Read our terms and conditions for using the quiz game." />
        <link rel="canonical" href="https://www.onepiecetrivia.com/terms" />
      </Helmet>

      <div className="legal-page-container">
        <div className="legal-page-content">
          <h1>Terms of Service</h1>
          <p className="last-updated">Last Updated: December 28, 2025</p>

          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using One Piece Trivia (onepiecetrivia.com), you accept and agree
              to be bound by these Terms of Service. If you do not agree to these terms, please
              do not use our website.
            </p>
          </section>

          <section>
            <h2>2. Description of Service</h2>
            <p>
              One Piece Trivia is a free online quiz game that tests your knowledge of the
              One Piece anime and manga series. Our services include:
            </p>
            <ul>
              <li>Character identification quizzes</li>
              <li>Image matching games</li>
              <li>Devil Fruit knowledge tests</li>
              <li>Score tracking and leaderboards</li>
            </ul>
          </section>

          <section>
            <h2>3. Intellectual Property</h2>
            <p>
              One Piece and all related characters, names, and imagery are trademarks of
              Eiichiro Oda, Shueisha, Toei Animation, and Funimation. This website is a
              fan-made project and is not affiliated with or endorsed by the official
              One Piece franchise.
            </p>
            <p>
              The quiz game mechanics, website design, and original content are the property
              of One Piece Trivia and are protected by copyright laws.
            </p>
          </section>

          <section>
            <h2>4. User Conduct</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Use the website for any unlawful purpose</li>
              <li>Attempt to hack, disrupt, or damage the website</li>
              <li>Use automated tools to access the website excessively</li>
              <li>Impersonate others or provide false information</li>
              <li>Interfere with other users' enjoyment of the service</li>
            </ul>
          </section>

          <section>
            <h2>5. Advertisements</h2>
            <p>
              Our website displays advertisements through Google AdSense to support the
              free service. By using our website, you acknowledge that:
            </p>
            <ul>
              <li>Advertisements are served by third-party networks</li>
              <li>Ad content is not controlled by One Piece Trivia</li>
              <li>You may see personalized ads based on your browsing history</li>
            </ul>
          </section>

          <section>
            <h2>6. Disclaimer of Warranties</h2>
            <p>
              The website is provided "as is" without warranties of any kind. We do not
              guarantee that:
            </p>
            <ul>
              <li>The service will be uninterrupted or error-free</li>
              <li>Quiz questions and answers are 100% accurate</li>
              <li>The website will be compatible with all devices</li>
            </ul>
          </section>

          <section>
            <h2>7. Limitation of Liability</h2>
            <p>
              One Piece Trivia shall not be liable for any indirect, incidental, special,
              or consequential damages arising from your use of the website.
            </p>
          </section>

          <section>
            <h2>8. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. Continued use of the
              website after changes constitutes acceptance of the new terms.
            </p>
          </section>

          <section>
            <h2>9. Governing Law</h2>
            <p>
              These terms shall be governed by and construed in accordance with applicable laws,
              without regard to conflict of law principles.
            </p>
          </section>

          <section>
            <h2>10. Contact</h2>
            <p>
              For questions about these Terms of Service, contact us at:
            </p>
            <p className="contact-email">chibidashofficial@gmail.com</p>          </section>
        </div>
      </div>
    </>
  );
};

export default TermsOfService;
